/**
 * Alpine component — allReviewsSummary
 *
 * Fetches the global review aggregate from the Okendo API and exposes
 * the computed average rating and total review count to the template.
 *
 * Props:
 * - labelTemplate {string} — translated string with __RATING__ and __COUNT__ placeholders
 *                            (e.g. "__RATING__/5 sur __COUNT__ avis")
 * - ariaTemplate  {string} — accessible label with the same placeholders
 * - okendoGroupId {string} — Okendo group ID
 *
 * Exposed data:
 * - rating      {number} — average rating rounded to 1 decimal (e.g. 4.5)
 * - ratingCount {number} — total number of reviews
 * - starsCount  {number} — rating rounded to nearest integer, used to highlight stars
 */

/* Okendo aggregate URL: https://api.okendo.io/v1/stores/{okendo_user_id}/review_aggregate */
const OKENDO_AGGREGATE_URL = 'https://api.okendo.io/v1/stores/ca7cd64c-740c-453a-a4c9-3d18933b028c/review_aggregate'

/* Okendo group aggregate URL: https://api.okendo.io/v1/stores/{okendo_user_id}/collections/{group_id}/review_aggregate */
const OKENDO_GROUP_AGGREGATE_URL = 'https://api.okendo.io/v1/stores/ca7cd64c-740c-453a-a4c9-3d18933b028c/collections/{group_id}/review_aggregate'

export default {
  name: 'allReviewsSummary',
  component(props: { labelTemplate: string; ariaTemplate: string; okendoGroupId: string }) {
    return {
      rating: 0,
      ratingCount: 0,
      starsCount: 0,
      labelTemplate: props.labelTemplate ?? '',
      ariaTemplate: props.ariaTemplate ?? '',

      async init() {
        try {
          const url = props.okendoGroupId
            ? OKENDO_GROUP_AGGREGATE_URL.replace('{group_id}', props.okendoGroupId)
            : OKENDO_AGGREGATE_URL
          const res = await fetch(url)
          if (!res.ok) return
          const data = await res.json()
          const agg = data?.reviewAggregate
          if (!agg) return

          const total: number = agg.ratingAndReviewValuesTotal ?? 0
          const count: number = agg.ratingAndReviewCount ?? 0

          if (count > 0) {
            this.ratingCount = count
            this.rating = Math.round((total / count) * 10) / 10
            this.starsCount = Math.round(total / count)
          }
        } catch (_) {
          // silently fail — no data displayed
        }
      }
    }
  }
}
